module.exports = __webpack_public_path__ + "fa-solid-900.1042e8ca1ce821518a2d.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-solid-900.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.eot
// module chunks = styles